export default {
  welcome: '欢迎登录',
  subtitle: '请输入您的账号和密码',
  email: '账号',
  emailPlaceholder: '请输入账号',
  password: '密码',
  passwordPlaceholder: '请输入密码',
  or: '或',
  noAccount: '还没有账号？',
  contactAdmin: '联系管理员',
  forgotPasswordTip: '请联系管理员重置密码',
  contactAdminTip: '请联系管理员获取账号',
};
